import _ from 'lodash';
import classNames from 'classnames';
import update from 'immutability-helper';
import objectAssign from 'object-assign';
import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import { Link, withRouter } from 'react-router';
import {bindActionCreators} from 'redux';
import FontAwesome from 'react-fontawesome';
import NumberFormat from 'react-number-format';
import * as clubActions from '../../../actions/clubActions';
import * as memberActions from '../../../actions/memberActions';
import * as regActions from '../../../actions/regActions';
import * as eventActions from '../../../actions/eventActions';
import PermissionWrapper from '../../../components/common/PermissionWrapper';
import Button from '../../../components/common/Button';
import Loading from '../../../components/Loading';
import ClubInfo from './ClubInfo';
import TeamInfo from './TeamInfo';
import AddClubMembers from './AddClubMembers';
import RegSummary from './RegSummary';
import toastr from 'toastr';
import jsondiffpatch from 'jsondiffpatch';
import * as calcPrice from '../../../components/common/calculatePrice';
import './registration.scss';

class RegisterClub extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.componentWillMount = this.componentWillMount.bind(this);
    this.componentWillReceiveProps = this.componentWillReceiveProps.bind(this);
    this.isStage = this.isStage.bind(this);
    this.mutedClass = this.mutedClass.bind(this);
    this.registeredWarning = this.registeredWarning.bind(this);
    this.renderApprovedMessage = this.renderApprovedMessage.bind(this);
    this.approvalToast = this.approvalToast.bind(this);
    this.updateBooleanField = this.updateBooleanField.bind(this);
    this.updateReverseBooleanField = this.updateReverseBooleanField.bind(this);
    this.updateField = this.updateField.bind(this);
    this.updateTimeField = this.updateTimeField.bind(this);
    this.newID = this.newID.bind(this);
    this.addTeam = this.addTeam.bind(this);
    this.removeTeam = this.removeTeam.bind(this);
    this.updateTeamList = this.updateTeamList.bind(this);
    this.updateRegMemberList = this.updateRegMemberList.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.askBeforeExit = this.askBeforeExit.bind(this);
    this.canCreate = this.canCreate.bind(this);
    this.canUpdate = this.canUpdate.bind(this);
    this.canSave = this.canSave.bind(this);
    this.approveChanges = this.approveChanges.bind(this);
    this.rejectChanges = this.rejectChanges.bind(this);
    this.state = {
      details: props.details,
      detailsDiff: {},
      errors: props.errors,
    };
  }

  componentWillMount() {
    if(this.props.clubId) {
      this.props.clubActions.loadClubDetails(this.props.clubId);
      this.props.memberActions.loadClubMembers(this.props.clubId);
    }
    if(this.props.eventId) {
      this.props.eventActions.loadEventTeamSettings(this.props.eventId);
    }
    if (this.props.eventId && this.props.clubId) {
      this.props.regActions.loadRegDetails(this.props.eventId, this.props.clubId);
    }
    this.props.router.setRouteLeaveHook(this.props.route, () => {
      if (!this.askBeforeExit()) {
        return false;
      } else {
        this.setState({
          details: this.props.details,
        });
        return true;
      }
    });
  }

  componentWillReceiveProps(nextProps) {
    if(!_.isEqual(nextProps.reviewDetailsUpdated, this.props.reviewDetailsUpdated) &&
      !_.isEmpty(nextProps.reviewDetails)) {
      let diff = jsondiffpatch.create({
        objectHash: function(obj) {
            // this function is used only to when objects are not equal by ref
            return obj.member_reg || obj._id || obj.id;
        },
        textDiff: {
          // default 60, minimum string length (left and right sides) to use text diff algorythm: google-diff-match-patch
          minLength: 10000
        },
        arrays: {
          detectMove: true,
          includeValueOnMove: true
        },
        // eslint-disable-next-line no-unused-vars
        propertyFilter: function(name, context) {
          let created_at = name == 'created_at';
          let updated_at = name == 'updated_at';
          let member_reg_details = name == 'member_reg_details';
          let member_details = name == 'member_details';
          let member_id = name == 'id';
          let member_identifier = name == 'identifier';
          return !_.some([created_at, updated_at, member_reg_details,
            member_details, member_id, member_identifier]);
        },
      });
      let detailsDiff = diff.diff(nextProps.reviewDetails, nextProps.details);
      this.setState({
        detailsDiff: detailsDiff
      });
    } else if(!_.isEqual(nextProps.reviewDetailsUpdated, this.props.reviewDetailsUpdated) &&
      _.isEmpty(nextProps.reviewDetails)) {
        this.setState({
          detailsDiff: {}
        });
      }
    if(!_.isEqual(nextProps.details, this.props.details)) {
      this.setState({
        details: nextProps.details,
      });
      if (nextProps.details.approved == false) {
        nextProps.regActions.loadRegReviewDetails(nextProps.eventId,
          nextProps.clubId);
      }
    }
    if(!_.isEqual(nextProps.details.comment, this.props.details.comment)) {
      this.setState({
        'savedComment': nextProps.details.comment
      });
    }
    if(!_.isEqual(nextProps.errors, this.props.errors)) {
      this.setState({
        errors: nextProps.errors,
      });
    }
  }



  isStage(desiredStage) {
    return desiredStage == this.props.stageId;
  }

  mutedClass(status) {
    return status ? '' : 'text-muted';
  }

  registeredWarning() {
    if (_.isEmpty(this.props.details)) {
      return (<div className="alert alert-info">
        {'Laster påmeldinginformasjon'}
      </div>);
    } else if (!this.props.details.id) {
      return null;
    } else if (this.props.details.archived) {
      return (
        <div className="alert alert-danger">
          {this.props.clubDetails.name + ' er nå ikke påmeldt. ' +
            'Du kan endre dette under klubbpåmelding.'}
        </div>
      );
    } else {
      return (
        <div className="alert alert-success">
          {this.props.clubDetails.name + ' er nå registrert som påmeldt.'}
        </div>
      );
    }

  }

  renderApprovedMessage() {
    if (this.props.details.approved == false) {
      return(
        <div className="alert alert-warning">
          {'Venter på godkjenning fra arrangør'}
        </div>
      );
    }
  }

  approvalToast() {
    // this.props.regActions.loadRegReviewDetails(this.props.eventId,
    //   this.props.clubId);
    toastr.warning('Venter på godkjenning fra arrangør.');
  }

  approveChanges() {
    if (confirm('Godkjenn: Er du sikker på at du ønsker å godkjenne endringene?')) {
      this.props.regActions.approveRegChanges(this.props.details, {approved: true});
    }
  }

  rejectChanges() {
    if (confirm('Avvis: Er du sikker på at du ønsker å avvise endringene?')) {
      this.props.regActions.approveRegChanges(this.props.details, {approved: false});
    }
  }

  updateBooleanField(event) {
    let details = objectAssign({}, this.state.details);
    details[event.target.name] = event.target.checked;
    return this.setState({
      details: details
    });
  }

  updateReverseBooleanField(event) {
    let details = objectAssign({}, this.state.details);
    details[event.target.name] = !event.target.checked;
    return this.setState({
      details: details
    });
  }

  updateField(event) {
    let details = objectAssign({}, this.state.details);
    details[event.target.name] = event.target.value;
    return this.setState({
      details: details
    });
  }

  updateTeamList(teamList) {
    let details = update(this.state.details, {teams:
      {$set: teamList}
    });
    return this.setState({
      details: details
    });
  }

  updateRegMemberList(regMemberList) {
    let details = update(this.state.details, {member_registrations:
      {$set: regMemberList}
    });
    return this.setState({
      details: details
    });
  }

  updateTimeField(field, time) {
    let eventDetails = objectAssign({}, this.state.eventDetails);
    eventDetails[field] = time;
    return this.setState({
      eventDetails: eventDetails
    });
  }

  newID() {
    return '_' + Math.random().toString(36).substr(2, 20);
  }

  addTeam(teamType, deafaultCategory, e) {
    let details = update(this.state.details,
      {teams: {
        $push: [{
          errors:[],
          members: [],
          member_estimates: [],
          _destroy: false,
          _updated: true,
          team_type: teamType,
          identifier: this.newID(),
          team_category: deafaultCategory,
          created_at: Date.now(),
        }]
      }}
    );
    this.setState({
      details: details
    });
    e.preventDefault();
  }

  removeTeam(team, e) {
    e.preventDefault();
    if (!confirm('Bekreft at du ønsker å slette')) {
      return;
    }
    let index = _.findIndex(this.state.details.teams, {identifier: team.identifier});
    let details = update(this.state.details, {teams: {[index]:
      {'_destroy': {$set: true}, '_updated': {$set: true}}
    }});
    this.setState({
      details: details
    });
  }

  submitForm(e) {
    if (this.props.loading) {
      e.preventDefault();
      return false;
    }
    e.preventDefault();
    let details = objectAssign({}, this.state.details);
    toastr.info('Sender skjema...');
    if (this.props.details.id) {
      this.props.regActions.update(details);
    } else {
      this.props.regActions.create(details);
    }
  }

  askBeforeExit() {
    let changed = !_.isEqual(this.props.details, this.state.details);
    if (changed && !confirm('Obs! Husk å lagre endringer før du går videre. ' +
    'Ønsker du å fortsette uten å lagre?')) {
      return false;
    } else {
      return true;
    }
  }

  canCreate() {
    if (this.props.details.permissions) {
      return (!this.props.details.id && this.props.details.permissions.create);
    } else {
      return false;
    }
  }

  canUpdate() {
    if (this.props.details.permissions) {
      return (this.props.details.id && this.props.details.permissions.update);
    } else {
      return false;
    }
  }

  canSave() {
    return (!!this.canCreate() || !!this.canUpdate());
  }

  render() {
    let totalPrice = calcPrice.calculatePrice(this.state.details,
      this.props.teamList, this.props.eventDetails);
    return (
      <div>
        <form onSubmit={this.submitForm}>
          <input type="submit" className="hidden" value="submit"/>
          {this.registeredWarning()}
          {this.renderApprovedMessage()}

          <nav className="navbar navbar-default navbar-custom">
            <div className="container">
              <ul className="nav navbar-nav">
                <li role="presentation"
                  className={classNames({active: this.isStage('info')})}>
                  <Link to={'/arrangement/' + this.props.eventId +
                    '/registrer/klubb/' + this.props.clubId + '/info'}>
                    Påmelding
                  </Link>
                </li>
                {this.props.details.id && <li role="presentation"
                  className={classNames({active: this.isStage('deltagere')})}>
                  <Link to={'/arrangement/' + this.props.eventId +
                    '/registrer/klubb/' + this.props.clubId + '/deltagere'}>
                    Deltagere
                  </Link>
                </li>}
                {this.props.details.id && this.props.teamList.map((team, index) => {
                  let url = '/arrangement/' +
                    this.props.eventId + '/registrer/klubb/' + this.props.clubId +
                    '/' + team.slug;
                  return (
                    <li key={index}
                      role="presentation"
                      className={classNames({active: this.isStage(team.slug)})}>
                      <Link to={url}>{team.name}</Link>
                    </li>
                  );
                })}
                <li role="presentation"
                  className={classNames({active: this.isStage('oppsummering')})}>
                  <Link to={'/arrangement/' + this.props.eventId +
                    '/registrer/klubb/' + this.props.clubId + '/oppsummering'}>
                    Oppsummering
                  </Link>
                </li>
              </ul>
              <p className="navbar-text">
                <Loading loading={this.props.loading} />
              </p>
            </div>
          </nav>
          <ClubInfo show={this.isStage('info')}
            detailsDiff={this.state.detailsDiff}
            updateBooleanField={this.updateBooleanField}
            updateReverseBooleanField={this.updateReverseBooleanField}
            updateField={this.updateField}
            updateTimeField={this.updateTimeField}
            toggleSection={this.toggleSection}
            submitForm={this.submitForm}
            details={this.state.details}
            errors={this.state.errors}
            route={this.props.route}
            clubId={this.props.clubId}
            eventId={this.props.eventId} />

          <AddClubMembers
            show={this.isStage('deltagere')}
            detailsDiff={this.state.detailsDiff}
            clubId={this.props.clubId}
            eventId={this.props.eventId}
            submitForm={this.submitForm}
            updateRegMemberList={this.updateRegMemberList}
            regMemberList={this.state.details.member_registrations || []}
            />
          {this.props.details.id && this.props.teamList.map((team, index) => {
            return (<TeamInfo key={index}
                show={this.isStage(team.slug)}
                team={team}
                teamIndex={index}
                teams={this.state.details.teams}
                addTeam={this.addTeam}
                detailsDiff={this.state.detailsDiff}
                removeTeam={this.removeTeam}
                updateTeamList={this.updateTeamList}
                submitForm={this.submitForm}
                regMemberList={this.state.details.member_registrations || []}
                route={this.props.route}
                clubId={this.props.clubId}
                eventId={this.props.eventId} />);
          })}
          <RegSummary
            show={this.isStage('oppsummering')}
            details={this.state.details}
            errors={this.state.errors}
            savedComment={this.state.savedComment}
            updateField={this.updateField}
            detailsDiff={this.state.detailsDiff}
            clubId={this.props.clubId}
            eventId={this.props.eventId}
            />
        </form>
        <nav className="navbar navbar-default navbar-custom navbar-fixed-bottom">
          <div className="container">
            <div className="btn-group dropup navbar-btn pull-left" role="group">
              <button type="button" className="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  Gå til <span className="caret"/>
              </button>
              <ul className="dropdown-menu">
                <li role="presentation"
                  className={classNames({active: this.isStage('info')})}>
                  <Link to={'/arrangement/' + this.props.eventId +
                    '/registrer/klubb/' + this.props.clubId + '/info'}>
                    Påmelding
                  </Link>
                </li>
                {this.props.details.id && <li role="presentation"
                  className={classNames({active: this.isStage('deltagere')})}>
                  <Link to={'/arrangement/' + this.props.eventId +
                    '/registrer/klubb/' + this.props.clubId + '/deltagere'}>
                    Deltagere
                  </Link>
                </li>}
                {this.props.details.id && this.props.teamList.map((team, index) => {
                  let url = '/arrangement/' +
                    this.props.eventId + '/registrer/klubb/' + this.props.clubId +
                    '/' + team.slug;
                  return (
                    <li key={index}
                      role="presentation"
                      className={classNames({active: this.isStage(team.slug)})}>
                      <Link to={url}>{team.name}</Link>
                    </li>
                  );
                })}
                <li role="presentation"
                  className={classNames({active: this.isStage('oppsummering')})}>
                  <Link to={'/arrangement/' + this.props.eventId +
                    '/registrer/klubb/' + this.props.clubId + '/oppsummering'}>
                    Oppsummering
                  </Link>
                </li>
                {!!totalPrice && <li role="separator" className="divider visible-xs-block visible-sm-block" />}
                {!!totalPrice && <li className="visible-sm-block visible-xs-block disabled">
                    <a href="#0" className="disabled">
                      {'Totalt: '}
                      <NumberFormat value={totalPrice}
                        displayType={'text'}
                        thousandSeparator={'.'}
                        decimalSeparator={','} suffix={' kr.'} />
                    </a>
                  </li>}
              </ul>
            </div>
            {!!totalPrice && <p className="navbar-text hidden-xs hidden-sm">
              {'Totalt: '}
              <NumberFormat value={totalPrice}
                displayType={'text'}
                thousandSeparator={'.'}
                decimalSeparator={','} suffix={' kr.'} />
            </p>}
            <div className="pull-right">
              {(this.props.details.id && !this.props.details.approved) && <button className="btn btn-warning navbar-btn"
                onClick={this.approvalToast}>
                <FontAwesome name="warning" />
              </button>}
              {' '}
              <PermissionWrapper
                currentUser={this.props.currentUser}
                allowed={['super_admin']}
                permissionType={'write'}
                object={this.props.eventDetails}>
                <span>
                  {(this.props.details.id && !this.props.details.approved) && <button className="btn btn-danger navbar-btn"
                    onClick={this.rejectChanges}>
                    <FontAwesome name="times" />
                  </button>}
                  {' '}
                  {(this.props.details.id && !this.props.details.approved) && <button className="btn btn-success navbar-btn"
                    onClick={this.approveChanges}>
                    <FontAwesome name="check" />
                  </button>}
                  {' '}
                </span>
              </PermissionWrapper>
              <Button
                permission={true}
                disabled={!this.canSave()}
                className={classNames('btn btn-primary navbar-btn',
                  {'disabled': this.props.loading})}
                onClick={this.submitForm}
                >
                {this.props.loading && <FontAwesome name="spinner" pulse />}
                {!this.props.loading && <FontAwesome name="save"/>}
                {' Lagre endringer'}
              </Button>
            </div>
          </div>
        </nav>
      </div>
    );
  }
}

RegisterClub.propTypes = {
  clubActions: PropTypes.object.isRequired,
  memberActions: PropTypes.object.isRequired,
  regActions: PropTypes.object.isRequired,
  eventActions: PropTypes.object.isRequired,
  teamList: PropTypes.array.isRequired,
  clubId: PropTypes.string,
  eventId: PropTypes.string,
  eventDetails: PropTypes.object,
  currentUser: PropTypes.object,
  location: PropTypes.object,
  route: PropTypes.object,
  router: PropTypes.object.isRequired,
  details: PropTypes.object,
  errors: PropTypes.object,
  clubDetails: PropTypes.object,
  reviewDetailsUpdated: PropTypes.number,
  stageId: PropTypes.string,
  children: PropTypes.oneOfType([
    React.PropTypes.string,
    React.PropTypes.array,
    React.PropTypes.element,
  ]),
  loading: PropTypes.bool,
};

function mapStateToProps(state, ownProps) {
  return {
    clubId: ownProps.params.clubId,
    stageId: ownProps.params.stageId,
    eventId: ownProps.params.eventId,
    teamList: state.events.teamList,
    currentUser: state.users.currentUser,
    eventDetails: state.events.eventDetails,
    details: state.registration.details,
    reviewDetails: state.registration.reviewDetails,
    reviewDetailsUpdated: state.registration.reviewDetailsUpdated,
    errors: state.registration.errors,
    clubDetails: state.clubs.clubDetails,
    loading: state.registration.loading,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    clubActions: bindActionCreators(clubActions, dispatch),
    memberActions: bindActionCreators(memberActions, dispatch),
    regActions: bindActionCreators(regActions, dispatch),
    eventActions: bindActionCreators(eventActions, dispatch),
  };
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(RegisterClub));



/** WEBPACK FOOTER **
 ** ./src/containers/events/register/RegisterClub.js
 **/